import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import PermissionsList from "./permissionsList";
import { fetchPermissionsList } from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
const Permissions = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions: grantedPerms } = state;

  const [permissions, setPermissions] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);
  const extractPermissions = () => {
    const perms = grantedPerms.filter((f) => f.module === "Permissions");
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await fetchPermissionsList();
    if (res?.data?.success && res?.data?.data) {
      setPermissions(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>Dashboard</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Permissions
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <PermissionsList
          permissions={permissions}
          setPermissions={setPermissions}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};
export default Permissions;
